import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FilterTemplateService {
  private apiUrl = environment.apiURL + 'filter-templates';

  constructor(private http: HttpClient) {}

  list(entity: string): Observable<any> {
    const params = new HttpParams().set('entity', entity);
    return this.http.get(this.apiUrl, { params });
  }

  create(entity: string, name: string, filters: Record<string, any>): Observable<any> {
    return this.http.post(this.apiUrl + '/new', { entity, name, filters });
  }

  delete(reference: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${reference}/delete`);
  }
}
